import { useEffect } from "react";
import { Link } from "wouter";
import { useMetaTags } from "@/hooks/useMetaTags";
import { useSuppressIntro } from "@/contexts/IntroContext";

// Liens proposés : évite le cul-de-sac et renforce le maillage interne.
const SUGGESTIONS = [
  { href: "/", label: "Accueil" },
  { href: "/portfolio", label: "Portfolio" },
  { href: "/tarifs", label: "Tarifs" },
  { href: "/blog", label: "Blog" },
  { href: "/villes", label: "Zones d'intervention" },
  { href: "/services", label: "Demande de devis" },
];

export default function NotFound() {
  // Sur un lien mort, on affiche l'erreur tout de suite : pas d'intro cinématique.
  useSuppressIntro();

  useMetaTags({
    title: "Page introuvable (404)",
    description:
      "Cette page n'existe pas ou a été déplacée. Retrouvez les prestations vidéo et drone de VEA STUDIO à Bordeaux et en Gironde.",
  });

  // Une 404 ne doit pas être indexée. La SPA répond 200 (soft 404) : on bascule
  // la balise robots existante (index.html en pose une) plutôt que d'en ajouter
  // une seconde, sinon les deux se contredisent. Valeur restaurée en sortie.
  useEffect(() => {
    const meta = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
    if (!meta) return;
    const previous = meta.content;
    meta.content = "noindex, follow";
    return () => {
      meta.content = previous;
    };
  }, []);

  return (
    <div
      className="min-h-screen w-full flex items-center justify-center px-4"
      style={{ background: "#0A0A0A" }}
    >
      <div className="max-w-lg w-full text-center">
        <p
          className="text-7xl font-bold mb-3"
          style={{ fontFamily: "'Playfair Display', serif", color: "var(--vea-or)" }}
        >
          404
        </p>

        <h1
          className="text-2xl font-bold mb-4"
          style={{ fontFamily: "'Playfair Display', serif", color: "#fff" }}
        >
          Cette page n'existe pas
        </h1>

        <p
          className="text-sm leading-relaxed mb-8"
          style={{ color: "rgba(255,255,255,0.50)", fontFamily: "'Montserrat', sans-serif" }}
        >
          Le lien est peut-être erroné ou la page a été déplacée. Voici de quoi
          retrouver votre chemin.
        </p>

        <nav
          aria-label="Pages suggérées"
          className="flex flex-wrap gap-x-5 gap-y-2 justify-center text-sm mb-9"
          style={{ color: "rgba(255,255,255,0.45)", fontFamily: "'Montserrat', sans-serif" }}
        >
          {SUGGESTIONS.map(({ href, label }) => (
            <Link
              key={href}
              href={href}
              className="transition-colors hover:text-white"
              style={{ color: "inherit" }}
            >
              {label}
            </Link>
          ))}
        </nav>

        <Link href="/">
          <button
            className="text-xs font-bold px-6 py-3 uppercase tracking-widest transition-all hover:opacity-90"
            style={{
              background: "var(--vea-rouge-bordeaux)",
              color: "white",
              fontFamily: "'Montserrat', sans-serif",
            }}
          >
            Retour à l'accueil
          </button>
        </Link>
      </div>
    </div>
  );
}
